import { AfterEmailVerification } from "@/modules/login/Login.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/email_verification")({
    component: AfterEmailVerification,
});
